import { render, staticRenderFns } from "./Composer.vue?vue&type=template&id=d0d2f286&"
import script from "./Composer.vue?vue&type=script&lang=js&"
export * from "./Composer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports